export interface EmbedIframeProps {
  id: string;
  src: string;
  backgroundColor: string;
  enableAutoHeightEmbed?: boolean;
}

export function EmbedIframe(props: EmbedIframeProps) {
  const iframeAllow = `autoplay; camera; fullscreen; microphone; clipboard-read; clipboard-write; self "${window.location.protocol}//${window.location.hostname}";`;

  const iframeSandbox = [
    "allow-same-origin",
    "allow-scripts",
    "allow-forms",
    "allow-modals",
    "allow-popups",
  ];

  const iframeElement = document.createElement("iframe");

  iframeElement.id = props.id;
  iframeElement.src = props.src;
  iframeElement.allow = iframeAllow;
  iframeElement.sandbox.add(...iframeSandbox);
  iframeElement.frameBorder = "0";
  iframeElement.scrolling = "yes";
  iframeElement.style.backgroundColor = props.backgroundColor;
  iframeElement.style.width = "100%";
  if (!props.enableAutoHeightEmbed) {
    iframeElement.style.height = "100%";
  }
  iframeElement.style.flex = "1";
  iframeElement.style.border = "none";

  return iframeElement;
}
